// Copyright © 2017-2021  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-row wrap class="noprint">
            <v-col cols="12" >
              <p class="headline font-weight-light">
                This tag represents this category.
              </p>
            </v-col>
          </v-row>
          <v-row wrap id="printablediv">
            <v-col cols="12">
              <p class="text-xs-center display-2">
              {{ codeValue }}
              </p>
            </v-col>
            <v-col cols="12">
              <div class="text-xs-center">
                <canvas ref="qr"></canvas>
              </div>
            </v-col>
          </v-row>
          <v-row wrap class="noprint">
            <v-col cols="12" md="6">
              <v-select
              v-model="size"
              label="Code Size"
              :items="sizes"
              chips
              >
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
</template>

<script>
import QRious from 'qrious'

export default {
  name: 'qr-holder',

  data () {
    return {
      code: null,
      categories: [],
      size: 300,
      sizes: [
        {
          text: 'Small',
          value: 100
        },
        {
          text: 'Medium',
          value: 300
        },
        {
          text: 'Large',
          value: 500
        },
        {
          text: 'X-Large',
          value: 700
        }
      ],
      tags: null
    }
  },

  mounted () {
    console.log(this)
    this.code = this.newCode(this.codeValue)
  },

  props: ['value', 'prefix'],

  computed: {
    codeValue: function () {
      if (this.prefix != null) {
        return this.prefix.concat(this.value)
      } else {
        return this.value
      }
    }
  },

  watch: {
    'size': function () {
      this.newCode()
    },

    'value': function () {
      this.newCode()
    },

    'prefix': function () {
      this.newCode()
    }
  },

  methods: {
    newCode: function () {
      return new QRious({
        element: this.$refs.qr,
        level: 'H',
        padding: 0,
        size: this.size,
        value: this.codeValue
      })
    }
  }
}
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  #printablediv, #printablediv * {
    visibility: visible;
  }
  #printablediv {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// QRHolder.vue?bc3ca242